import type { AllRouteEndpoints } from "../routeTypes";

export const deleteAppGroupIdOperatorMcpConnectionsConnectionIdCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/operator_mcp_connections",
  "/:app_group_id/operator_mcp_connections/tools",
];
